const gas_units = [
    ['m3', 'm\u00B3'],
    ['mcf', 'Thousand Cubic Feet'],
    ['mmbtu', 'Metric Million British Thermal Units'],
    ['gj', 'Gigajoules'],
    ['therm', 'Therm'],
    ['l', 'Litres'],
];

export default gas_units;